class Zoom {

  /* ========================================================================
   * Zoom.js
   * ======================================================================== */
  constructor( el ) {
    this.el = el;
  }

  async init(){
    let zoom = this;

    let currentzoom = Cookies.get('zoom')?? 'middle';
    [... zoom.el.querySelectorAll('span')].map( fontsizeel => {
      fontsizeel.classList.remove( 'selected' );
    });
    zoom.el.querySelector('.fontsize-'+currentzoom).classList.add( 'selected' );

    let fontsize = ( ( currentzoom == 'middle' )? '' : ( currentzoom == 'min' )? '14px' : '22px' );

    if(window.innerWidth < 992){
      fontsize = ( ( currentzoom == 'middle' )? '' : ( currentzoom == 'min' )? '12px' : '20px' );
    }

    if(fontsize != ""){
      document.documentElement.style.fontSize = fontsize;
    }


    [... zoom.el.querySelectorAll('span')].map( clickel => {
      clickel.addEventListener('click',function(e){
        e.preventDefault();
        let currentzoom = clickel.dataset.fontsize;
        [... zoom.el.querySelectorAll('span')].map( fontsizeel => {
          fontsizeel.classList.remove( 'selected' );
        });
        zoom.el.querySelector('.fontsize-'+currentzoom).classList.add( 'selected' );
        let fontsize = ( ( currentzoom == 'middle' )? '' : ( currentzoom == 'min' )? '14px' : '22px' );
        if(window.innerWidth < 992){
          fontsize = ( ( currentzoom == 'middle' )? '' : ( currentzoom == 'min' )? '12px' : '20px' );
        }
        document.documentElement.style.fontSize = fontsize;

        if(fontsize != ""){
          document.documentElement.style.fontSize = fontsize;
        }
        

        Cookies.set( 'zoom', currentzoom, { domain: '.'+window.location.hostname.split('.').reverse()[1]+'.'+window.location.hostname.split('.').reverse()[0], path: '/' } );
      });
    });
  }
}

DOMReady( function(){
  [... document.querySelectorAll('.fontsize-change')].map( elt => {
    let zoom = new Zoom(elt);
    zoom.init();
  });
});
